import { DrWebModule } from '../interfaces/drweb-module';




export class DrWebModules {
    public Finances:boolean;
    public ReportGenerator:boolean;
    public Forms:boolean;
    public Scheduler:boolean;

    constructor(private modules: DrWebModule[]){
        for (let index = 0; index < modules.length; index++) {            
            const element = modules[index];
            this[element.Name] = element.Active;
        }
        
    }
    
}


